import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 280;
const useStylesUnilens = makeStyles((theme) => ({
  root: {},
  appBar: {
    backgroundColor: "transparent",
    boxShadow: "none",
    position: "relative",
    paddingRight: 5,
    paddingTop: 0, 
    "@media(max-width:767px)": { 
      paddingRight: 0,
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 20,
    },
  },
  wrappedBlock: {
    // [theme.breakpoints.up(1100)]: {
      flexWrap: 'nowrap'
    // }
  },
  centerTitle: {
    [theme.breakpoints.up(1280)]: {
      width: 'auto',
      flex: 1,
      whiteSpace: 'nowrap'
    },
    [theme.breakpoints.down(1280)]: {
      position:'absolute',
      top:'-38px',
      left: '55px',
      justifyContent: 'flex-start'
    }
  }, 
  navStyleCustom: {
      whiteSpace: 'nowrap'
  },
  toolbar: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  configWrapper: {
    maxWidth: "100%",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  logo: {
    width: 80 + "%",
    marginTop: 15,
  },
  leftSpacing: {
    //paddingLeft: 20,
  },
  title: {
    color: "#000",
    fontSize: "20px",
    [theme.breakpoints.down(767)]: {
      fontSize: '16px'
    }
  },
  panel: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    margin: 10,
    maxWidth: "100%",
    height:"calc(100vh - 120px)",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "75%"
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "79%"
    }
  },
  leftPanel: {
    borderRadius: 0,
    padding: 0,
    width: "100%",
  },
  rightPanel: {
    borderRadius: 0,
    padding: 10,
    width: "100%",
  },

  subLinks: {
    padding: 0,
    width: "100%",
  },
  link: {
    display: "block",
    width: "100%",
    padding: "6px 16px",
    lineHeight: 1.5,
    fontSize: 15,
    color: "#444",
    fontWeight: "bold",
    textDecoration: "none",
    border: "none",
    borderBottom: "1px solid #eee",
    whiteSpace: "break-spaces"
  },
  menuItem: {
    padding: 0,
    border: "none",
  },
  divider: {
    height: ".05rem",
  },
  userMenu: {
    order: -1,
    zIndex: 9999,
    position: "absolute",
    top: "-50px",
    right: 0,
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.up("md")]: {
      order: 3,
      position: "relative",
      display: "flex",
      top: "0px",
      alignItems: "flex-end",
    },
  },
}));

export default useStylesUnilens;
